import React from "react";
import { motion } from "framer-motion";
import "./Careers.css";

const Careers = () => {
  return (
    <div className="careers-page">
      {/* Hero */}
      <section className="careers-hero">
        <img
          src="/images/careers-banner.jpg"
          alt="Sri Vani Careers"
          className="careers-hero-img"
        />
      </section>

      {/* Intro */}
      <section className="careers-intro-section">
        <div className="container">
          <motion.div
            className="careers-intro-inner"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <span className="careers-badge">Join Our Team</span>
            <h2>Shape the Future with Sri Vani</h2>
            <p>
              At SVECT, the management offers a healthy working atmosphere and a
              nurturing environment. We are always on the lookout for skilled and
              dedicated professionals to join our team. We provide frequent
              soft-skills training sessions to help our staff grow and excel in
              their careers.
            </p>
          </motion.div>
        </div>
      </section>

      {/* General Resume CTA */}
      <section className="careers-resume-section">
        <div className="container">
          <motion.div
            className="careers-resume-inner"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <p>
              Apply now — mail your latest resume to{" "}
              <a href="mailto:careers@srivani.org">careers@srivani.org</a>
            </p>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Careers;
